import { render, staticRenderFns } from "./Activate2Fa.vue?vue&type=template&id=4fc06377"
import script from "./Activate2Fa.vue?vue&type=script&lang=ts"
export * from "./Activate2Fa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports